import { takeEvery, put, call } from "redux-saga/effects";
import * as types from "./actionTypes";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

function* fetchemployeepayslipsSaga({ payload }) {
  try {
    console.log("payload>>>>>>>>>>", payload)
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_PAYSLIP_GENERATE, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve module!"); }
    yield put({ type: types.FETCH_EMPLOYEE_PAYSLIPS_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_PAYSLIPS_FAILURE, payload: response.data });
  }
}

function* fetchsalaryregisterSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_WAGELIST_REPORT, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve module!"); }
    yield put({ type: types.FETCH_EMPLOYEE_WAGEREGISTER_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_WAGEREGISTER_FAILURE, payload: response.data });
  }
}

function* fetchBankStatementSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_BANK_STATEMENT_DETAILS, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve bank statement details!"); }
    yield put({ type: types.FETCH_BANKSTATEMENT_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_BANKSTATEMENT_FAILURE, payload: error.message });
  }
}

function* fetchSectionWageListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_SECTION_WAGE_LIST, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve section wage list!"); }
    yield put({ type: types.FETCH_SECTION_WAGE_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_SECTION_WAGE_FAILURE, payload: error.message });
  }
}

function* fetchemployeectcListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_FETCH_EMPLOYEE_CTC_LIST, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve section wage list!"); }
    yield put({ type: types.FETCH_EMPLOYEE_CTCT_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_EMPLOYEE_CTCT_LIST_FAILURE, payload: error.message });
  }
}

function* fetchMonthlyESIListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_MONTHLY_ESI_LIST, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve monthly ESI list!"); }
    yield put({ type: types.FETCH_MONTHLY_ESI_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_MONTHLY_ESI_LIST_FAILURE, payload: error.message });
  }
}

function* fetchMonthlyPFListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_MONTHLY_PF_LIST, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve monthly PF list!"); }
    yield put({ type: types.FETCH_MONTHLY_PF_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_MONTHLY_PF_LIST_FAILURE, payload: error.message });
  }
}

function* fetchPayRegSummaryListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYREG_SUMMARY_LIST, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve pay register summary list!"); }
    yield put({ type: types.FETCH_PAYREG_SUMMARY_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_PAYREG_SUMMARY_LIST_FAILURE, payload: error.message });
  }
}

function* fetchGetPayEmployeeReportListSaga({ payload }) {
  try {
    const response = yield call(post, process.env.REACT_APP_GETPAY_EMPLOYEE_REPORT, payload);
    if (!response || response.status !== "success") { throw new Error(response?.message || "Failed to retrieve pay Employee Report List list!"); }
    yield put({ type: types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST_SUCCESS, payload: response.data });
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put({ type: types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST_FAILURE, payload: error.message });
  }
}

function* PayrollReportsSaga() {
  yield takeEvery(types.FETCH_EMPLOYEE_PAYSLIPS, fetchemployeepayslipsSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_WAGEREGISTER, fetchsalaryregisterSaga);
  yield takeEvery(types.FETCH_BANKSTATEMENT_DETAILS, fetchBankStatementSaga);
  yield takeEvery(types.FETCH_SECTION_WAGE_LIST, fetchSectionWageListSaga);
  yield takeEvery(types.FETCH_EMPLOYEE_CTCT_LIST, fetchemployeectcListSaga);
  yield takeEvery(types.FETCH_MONTHLY_ESI_LIST, fetchMonthlyESIListSaga);
  yield takeEvery(types.FETCH_MONTHLY_PF_LIST, fetchMonthlyPFListSaga);
  yield takeEvery(types.FETCH_PAYREG_SUMMARY_LIST, fetchPayRegSummaryListSaga);
  yield takeEvery(types.FETCH_GETPAY_EMPLOYEE_REPORT_LIST, fetchGetPayEmployeeReportListSaga);

}


export default PayrollReportsSaga;